import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "HomePage", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Show Events ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Manage My Events ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NearIsConnectedPage = _resolveComponent("NearIsConnectedPage")!
  const _component_ConnectWalletPage = _resolveComponent("ConnectWalletPage")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isSignedIn)
      ? (_openBlock(), _createBlock(_component_NearIsConnectedPage, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isSignedIn)
      ? (_openBlock(), _createBlock(_component_ConnectWalletPage, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isSignedIn)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 2,
          class: "home-page__events-link",
          to: "/events"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isSignedIn)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 3,
          class: "home-page__events-link",
          to: "/events-management"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}